<template>
    <div class="reset-password">
        <div class="spacer p20"></div>
        <div class="spacer p20"></div>
        <div class="spacer p20"></div>
        <v-row class="justify-center align-center forget-password mx-0">
            <v-card outlined class="form-card">
                <h1>{{ metaData.header }}</h1>
                <div class="spacer p20"></div>
                <div class="spacer p20"></div>
                <v-form v-model="model.valid" v-if="!successMessage">
                    <v-row class="justify-center" v-if="errorMessage">
                        <v-col cols="12" sm="6" md="4">
                            <v-alert type="error">{{ errorMessage }}</v-alert>
                        </v-col>
                    </v-row>
                    <v-row class="justify-center">
                        <div class="row-content">
                            <v-text-field
                                    label="Email"
                                    required
                                    v-model="model.email"
                                    :rules="rules.email"
                                    color="orange lighten-2"
                            ></v-text-field>
                        </div>
                    </v-row>
                    <div class="spacer p20"></div>
                    <div class="spacer p20"></div>
                    <v-row class="justify-center">
                        <div class="row-content">
                            <v-btn
                                    width="100%"
                                    class="main--yellow white--text"
                                    :disabled="!model.valid"
                                    @click="sendData"
                                    elevation="0"
                            >
                                {{ $t('requestPassword') }}
                            </v-btn>
                        </div>
                    </v-row>
                </v-form>
                <v-row class="justify-center" v-if="successMessage">
                    <div class="row-content">
                        <v-alert type="success">{{ successMessage }}</v-alert>
                    </div>
                </v-row>
            </v-card>
        </v-row>
    </div>
</template>

<script>
    import AuthService from '../../../app-front/services/api/AuthService';

    export default {
        name: "ResetPassword",
        data(){
            return {
                errorMessage: '',
                metaUrl: '/forget-password',
                model: {
                    valid: false,
                    email: ''
                },
                rules: {
                    email: [
                        v => !!v || this.$t('emailRequired'),
                        v => /.+@.+/.test(v) || this.$t('emailInvalid')
                    ]
                },
                successMessage: ''
            }
        },
        methods: {
            sendData(){
                const credentials = {
                    email: this.model.email
                };
                AuthService.sendResetPasswordEmail(credentials).then(res => {
                    if (res.data.error) {
                        this.errorMessage = res.data.error;

                        setTimeout(() => {
                            this.errorMessage = '';
                        }, 2000);
                    }

                    if(res.data.success) {
                        this.successMessage = res.data.success.message;
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.errorMessage = this.$t('requestPasswordError');
                });
            }
        }
    }
</script>

<style scoped>

</style>
